import BaseTracker from './base-tracker';

export default class PauseTracker extends BaseTracker {
  start() {
    this._player.addEventListener('pause', this._onPause);
  }

  _onPause = () => {
    this.track();
  };

  stop() {
    this._player.removeEventListener('pause', this._onPause);
  }
}
